<template lang="pug">
  .shopify
    v-container(style="max-width:600px")
      v-layout.mt-3(v-if="!setupDone")
        v-row.fill-height.ma-0(align='center' justify='center')
          div.mx-auto
            v-img.mx-auto(:src="require('@/assets/images/shopify_logo.png')" style="width:100px" contain)

      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

      v-card.mt-6(v-else flat)
        v-card-title
          v-layout
            div(v-if="setupDone") Setup Completed
            div(v-else)
              template(v-if="step === 1")
                p.h6.ma-0 Set API keys
                p.p2.mt-2.ma-0.primary500--text Refer how to generate API keys&nbsp;
                  span.p2.accent--text(href="https://help.shopify.com/en/manual/apps/private-apps/" target="_blank") here
                  | .
                p.ma-0.p2.primary500--text Make sure to choose <b>Read/Write</b> as level of access.
              template(v-if="step === 2")
                p.h6.ma-0 Check permissions
                p.p2.mt-2.ma-0.primary500--text Please make sure all permissions are granted.
              template(v-if="step === 3")
                p.h6.ma-0 Sync Settings

        v-window.pa-4(v-if='!setupDone' v-model='step' touchless)
          v-window-item(:value="1")
            v-form(ref="form")
              .api-key
                p.label.basic600--text.text-uppercase Shopify Domain
                v-text-field.p1(solo flat background-color="basic200"    height="40" v-model='shopify.domain' label="Domain" placeholder="eg: arbatravel.myshopify.com" outlined dense persistent-hint :rules="rules.not_empty")
                p.label.basic600--text.text-uppercase API Key
                v-text-field.p1(solo flat background-color="basic200"    height="40" v-model='shopify.api_key' label="API Key" placeholder="Insert your API key here" outlined dense persistent-hint :rules="rules.not_empty")
                p.label.basic600--text.text-uppercase Password
                v-text-field.p1(solo flat background-color="basic200"    height="40" v-model='shopify.password' label="Password" @focus="shopify.password = ''"  placeholder="eg: shppa_******************************" outlined dense persistent-hint :rules="rules.not_empty")
                p.label.basic600--text.text-uppercase Shared Secret
                v-text-field.p1(solo flat background-color="basic200"    height="40" v-model='shopify.shared_secret' label="Shared Secret" @focus="shopify.shared_secret = ''" placeholder="eg: shpss_******************************" outlined dense persistent-hint :rules="rules.not_empty")

          v-window-item(:value="2")
            div(v-if="fetchPermission" align="center")
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            v-row(v-else no-gutters justify="center")
              v-col(cols="7" v-if="permissions.length > 0")
                template(v-for="permission in permissions")
                  v-layout.my-3
                    p.my-auto {{ permission.name }}
                    v-spacer
                    v-icon.my-auto(:color="permission.status ? 'success' : 'error'") {{ permission.status ? 'mdi-check-circle' : 'mdi-close-circle' }}
              v-col(v-else)
                p.error--text.text-center Unable to connect with:
                p.error--text.font-weight-bold.text-center {{ shopify.domain }}.
                p.error--text.text-center Please make sure consumer key and secret are correct.

          v-window-item(:value="3")
            v-form(ref="form")
              .api-key
                p.mb-0 Warehouse Priority
                p.mb-3.text-caption.primary--text Drag the product on
                  v-icon.mx-1(color="primary" small) mdi-swap-vertical-bold
                  | to move up or down
                draggable(tag="div" :list="warehouses" handle=".handle" @start="drag=true"  @end="drag=false")
                  template(v-for="(element, idx) in warehouses")
                    v-card.my-1(outlined elevation="1" :class="{ 'drag-active': drag }")
                      v-list-item.px-3
                        v-list-item-action.my-0.mr-3
                          v-avatar.caption(color="grey lighten-2" size="20") {{ idx + 1 }}
                        v-list-item-content {{ element.name }}
                        v-list-item-icon.my-auto.ml-1.handle(:class="{ 'drag-inactive': !drag }")
                          v-icon(size="26") mdi-swap-vertical-bold
                y-switch.mt-6(v-model="syncSwitch" label="Sync Product Inventory")
                y-switch(v-model="manage_order" label="Manage Order" @change="manageOrderChange")

        v-window(v-else)
          v-window-item
            v-row.fill-height.ma-0(align='center' justify='center')
              div.mx-auto
                v-img.mx-auto(:src="require('@/assets/images/shopify_logo.png')" style="width:120px" contain)
                div.mt-2.caption.text-center Congratulation! <br> Your Shopify site is now connected to Yezza.

        v-card-actions
          v-btn.button-AA-medium(v-show='step > 1 && step < totalstep' text height=32 @click='goBack()')
            | Back
          v-spacer
          v-btn.button-AA-medium.white--text(v-if='step === totalstep' color='info500' height=32 depressed @click="finish")
            | Finish
          v-btn.button-AA-medium.white--text(v-else color='info500' height=32 depressed @click='clickNextButton()' :loading="loading" :disabled="disableNext")
            | Next
</template>

<script>
import { mapActions } from 'vuex'
import draggable from 'vuedraggable'
export default {
  name: 'SetupShopify',
  components: { draggable },
  props: [ 'company', 'ecommerce'],
  data: () => ({
    drag: false,
    loading: false,
    setupDone: false,
    isFetching: true,
    fetchPermission: false,
    step: 1,
    totalstep: 4,
    disableNext: false,
    shopify: {
      domain: '',
      api_key: '',
      password: '',
      shared_secret: ''
    },
    permissions: [],
    warehouses: [],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'Item is required', (v) => v != 0|| 'Item is required']
    },
    manage_order: false
  }),
  computed: {
    syncSwitch: {
      get () {
        if (this.shopify.sync_product_inventory === 'both') {
          return true
        } else {
          return false
        }
      },
      set (val) {
        if (val) {
          this.shopify.sync_product_inventory = 'both'
        }
        else {
          this.shopify.sync_product_inventory = 'inactive'
        }
      }

    }
  },
  watch: {
    ecommerce: {
      deep: true,
      immediate: true,
      handler (val) {
        if(val.id) {
          this.fetchWoo()
        } else {
          this.isFetching = false
        }
      }
    },
    step (val) {
      if (val === 1) {
        this.disableNext = false
      } else if (val === 2) {
        this.checkPermission (this.shopify.id)
      } else if (val === 3) {
        this.fetchLocation (this.shopify.id)
      } else if (val === this.totalstep) {
        this.setupDone = true
      }
    }
  },
  mounted () {
    this.$axios.get(`/forms?company=${this.company.id}&type=shopify&include_hidden=true`)
      .then(resp => {
        if (resp.data.results.length > 0) {
          this.manage_order = true
        }
      }).catch(() => {})
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchWoo () {
      this.shopify = {...this.ecommerce}
      this.isFetching = false
    },
    checkPermission (val) {
      this.fetchPermission = true
      this.axios.get(`/ecommerce/shopify/${val}/permissions`)
      .then(resp => {
        this.fetchPermission = false
        if (resp.status === 200) {
          this.permissions = resp.data
          let check = [...this.permissions.filter(f => f.status === false)]
          if (check.length > 0) {
            this.disableNext = true
          } else {
            this.disableNext = false
          }
        } else {
          this.permissions = []
          this.disableNext = true
        }
      })
    },
    fetchLocation (val) {
      this.location = true
      this.axios.get('/ecommerce/shopify/locations', { params: { settings: val }})
      .then(resp => {
        this.warehouses = resp.data.results
      })
    },
    goBack () {
      this.step--
    },
    clickNextButton () {
      if (this.step === 1) {
        if (!this.$refs.form.validate()) {
          return
        }
        this.loading = true
        if (this.shopify.id) {
          let data = {
            domain: this.shopify.domain,
            api_key: this.shopify.api_key
          }
          if (this.ecommerce.password !== this.shopify.password) {
            data.password =  this.shopify.password
          }
          if (this.ecommerce.consumer_secret !== this.shopify.consumer_secret) {
            data.shared_secret =  this.shopify.shared_secret
          }
          this.axios.patch(`/ecommerce/shopify/${this.shopify.id}/`, data)
          .then(resp => {
            this.step++
            this.$emit('update:ecommerce', resp.data)
            // this.setupDone = true
          })
          .catch(() => {
            this.showMessage(['error', `Unable to connect with ${this.shopify.domain}. Please make sure consumer key and secret are correct.`])
          })
          .finally(() => {
            this.loading = false
          })
        } else {
          let data = {
            company: this.company.id,
            domain: this.shopify.domain,
            api_key: this.shopify.api_key,
            password: this.shopify.password,
            shared_secret: this.shopify.shared_secret,
          }
          this.axios.post(`/ecommerce/shopify/`, data)
          .then(resp => {
            this.step++
            this.$emit('update:ecommerce', resp.data)
            // this.setupDone = true
          })
          .catch(() => {
            this.showMessage(['error', `Unable to connect with ${this.shopify.domain}. Please make sure consumer key and secret are correct.`])
          })
          .finally(() => {
            this.loading = false
          })
        }
      } else if (this.step === 2) {
        this.$axios.post(`/ecommerce/shopify/${this.shopify.id}/sync_locations`)
        .then(resp => {
          if (resp.status === 200) {
            this.step++
          }
        }).catch(() => {})
      } else if (this.step === 3) {
        this.loading = true
        this.axios.patch(`/ecommerce/shopify/${this.shopify.id}/`, { sync_product_inventory: this.shopify.sync_product_inventory })
        .then(resp => {
          this.$emit('update:ecommerce', resp.data)
          this.warehouses.forEach((o, index) => {
            this.$axios.put(`/ecommerce/shopify/locations/${o.id}`, { position: index }).catch(() => {})
          })
          this.step++
        })
        .catch(() => {
          this.showMessage(['error', `Unable to connect with ${this.shopify.domain}. Please make sure consumer key and secret are correct.`])
        })
        .finally(() => {
          this.loading = false
        })
      }
    },
    finish () {
      this.$axios.post(`/ecommerce/shopify/${this.shopify.id}/sync_locations`).catch(() => {})
      document.location.href = '/admin/settings/shopify'
    },
    manageOrderChange () {
      if (this.manage_order === true) {
        this.$axios.get(`/forms?company=${this.company.id}&type=shopify&include_hidden=true`)
          .then(resp => {
            if (resp.data.results.length === 0) {
              let params = {
                company : this.company.id,
                name : 'Shopify',
                email_enabled : false,
                email_required : false,
                layout : 'inquiry',
                extra_fields : [],
                type: 'shopify',
                members: [this.company.primary_owner],
                hidden: true
              }
              this.$axios.post(`/forms/`, params)
                .catch(() => {
                  this.showMessage(['error', this.$t('error_message.error_occured')])
                })
            }
          }).catch(() => {})
      } else {
        this.$axios.get(`/forms?company=${this.company.id}&type=shopify&include_hidden=true`)
          .then(resp => {
            if (resp.data.results.length > 0) {
              this.$axios.patch(`/forms/${resp.data.results[0].id}/`, { status: 'deleted' })
                .then(() => {
                  this.showMessage(['success', this.$t('success_message.manage_order_disabled')])
                })
                .catch(() => {
                  this.showMessage(['error', this.$t('error_message.error_occured')])
                })
            }
          }).catch(() => {})
      }
    }
  }
}
</script>

<style scoped>
.drag-inactive { cursor: grab; }
.drag-active { cursor: grabbing; }
.handle {
  /* float: left; */
  padding: 8px 0 8px 8px;
}
</style>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

</style>


<i18n>
{}
</i18n>
